<footer class="mfg-footer">
    <div class="d-flex flex-row justify-content-between w-100">
        <div class="d-flex flex-column align-items-center gap-25" [class.selected]="selectedIcon === 'home'"
            (click)="changeIconColor('/shop/mfg-land', 'home')">
            <img [src]="selectedIcon !== 'home' ? homeIcon : homeIconFill" loading="lazy" class="icon-img" alt="">
            <!-- <img [src]="homeIconFill" loading="lazy" *ngIf="selectedIcon != 'home'" class="icon-img icon-select" alt=""> -->
            <span class="cursor-pointer icon-text" [class.selected]="selectedIcon === 'home'">Home</span>
        </div>
        <div class="d-flex flex-column align-items-center  gap-25" [class.selected]="selectedIcon === 'shop'"
            (click)="changeIconColor('/shop/machine-prod-items', 'shop')">
            <img [src]="selectedIcon!== 'shop' ? shopIcon : shopIconFill" loading="lazy" class="icon-img " alt="">

            <span class="cursor-pointer icon-text" [class.selected]="selectedIcon === 'shop'">Shop</span>
        </div>
        <div class="d-flex flex-column align-items-center  gap-25" [class.selected]="selectedIcon === 'cart'"
            (click)="changeIconColor('/shop/mfg-cart', 'cart')">
            <img [src]="selectedIcon!=='cart' ? cartIcon : cartIconFill" loading="lazy" class="icon-img" alt="">
            <span class="item-count" *ngIf="cartCount!=0">{{cartCount}}</span>

            <span class="cursor-pointer icon-text " [class.selected]="selectedIcon === 'cart'">Cart</span>
        </div>
        <div class="d-flex flex-column align-items-center  gap-25" [class.selected]="selectedIcon === 'profile'"
            (click)="changeIconColor('/shop/myaccount', 'profile')">
            <img [src]="selectedIcon !== 'profile' ? profileIcon : profileIconFill" loading="lazy" class="icon-img"
                alt="">

            <span class="cursor-pointer icon-text" [class.selected]="selectedIcon === 'profile'">Profile</span>
        </div>
    </div>
</footer>